import React, { useState, useEffect, useRef } from 'react';
import { ScheduleComponent, Day, Week, WorkWeek, Month, Agenda, Inject, ViewsDirective, ViewDirective } from '@syncfusion/ej2-react-schedule';
import api from '../services/api';

function CalendarPage() {
  const scheduleRef = useRef(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    loadEvents();
  }, [selectedDate]);

  const loadEvents = async () => {
    setLoading(true);
    try {
      const startDate = new Date(selectedDate);
      startDate.setMonth(startDate.getMonth() - 1);
      const endDate = new Date(selectedDate);
      endDate.setMonth(endDate.getMonth() + 2);

      const response = await api.get('/calendar/events', {
        params: {
          startUtc: startDate.toISOString(),
          endUtc: endDate.toISOString()
        }
      });

      const mappedEvents = (response.data || []).map(event => ({
        Id: event.eventId,
        Subject: event.subject,
        StartTime: new Date(event.startUtc),
        EndTime: new Date(event.endUtc),
        IsAllDay: event.isAllDay,
        Location: event.location,
        Description: event.body,
        RecurrenceRule: event.recurrenceRule
      }));

      setEvents(mappedEvents);
    } catch (error) {
      console.error('Failed to load events:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleActionComplete = async (args) => {
    if (args.requestType === 'eventCreated') {
      try {
        const event = args.data[0];
        await api.post('/calendar/events', {
          subject: event.Subject,
          startUtc: event.StartTime,
          endUtc: event.EndTime,
          isAllDay: event.IsAllDay,
          location: event.Location,
          body: event.Description
        });
        loadEvents();
      } catch (error) {
        console.error('Failed to create event:', error);
      }
    } else if (args.requestType === 'eventChanged') {
      try {
        const event = args.data[0];
        await api.put(`/calendar/events/${event.Id}`, {
          subject: event.Subject,
          startUtc: event.StartTime,
          endUtc: event.EndTime,
          isAllDay: event.IsAllDay,
          location: event.Location,
          body: event.Description
        });
      } catch (error) {
        console.error('Failed to update event:', error);
      }
    } else if (args.requestType === 'eventRemoved') {
      try {
        const event = args.data[0];
        await api.delete(`/calendar/events/${event.Id}`);
      } catch (error) {
        console.error('Failed to delete event:', error);
      }
    }
  };

  const handleNavigate = (args) => {
    setSelectedDate(args.currentDate);
  };

  return (
    <div className="calendar-container">
      {loading && (
        <div style={{ 
          position: 'absolute', 
          top: '50%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)',
          zIndex: 10
        }}>
          <div className="loading-spinner"></div>
        </div>
      )}
      <ScheduleComponent
        ref={scheduleRef}
        height="100%"
        selectedDate={selectedDate}
        eventSettings={{ dataSource: events }}
        actionComplete={handleActionComplete}
        navigating={handleNavigate}
        currentView="Month"
        showQuickInfo={true}
        cssClass="dark-schedule"
      >
        <ViewsDirective>
          <ViewDirective option="Day" />
          <ViewDirective option="Week" />
          <ViewDirective option="WorkWeek" />
          <ViewDirective option="Month" />
          <ViewDirective option="Agenda" />
        </ViewsDirective>
        <Inject services={[Day, Week, WorkWeek, Month, Agenda]} />
      </ScheduleComponent>
    </div>
  );
}

export default CalendarPage;

